<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <vs-card>
      <form role="form" @submit.stop.prevent="buscar" class="mb-2">
        <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->
        <div :class="`vx-row pb-0 ${filtroAvancado ? 'pb-10' : 'pb-6 mb-0'}`">
          <div
            :class="`vx-col mt-3 ${
              !vistoria || b2c ? 'sm:w-1/5' : 'sm:w-1/6'
            } w-full`"
          >
            <span>Código</span>
            <vs-input
              class="w-full"
              name="codigo"
              id="codigo"
              v-model="formFiltro.idProposta"
              :state="validateState('codigo')"
              :danger="validateClass('codigo')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
          </div>

          <div
            :class="`vx-col mt-3 ${
              !vistoria || b2c ? 'sm:w-1/5' : 'sm:w-1/6'
            } w-full`"
          >
            <span>Id Diversos</span>
            <vs-input
              class="w-full"
              name="id diversos"
              id="id-diversos"
              v-model="formFiltro.idFrota"
              :state="validateState('id diversos')"
              :danger="validateClass('id diversos')"
            />
          </div>

          <div v-if="!vistoria || b2c" class="vx-col mt-3 sm:w-2/5 w-full">
            <span>Data Inicial</span>

            <div class="sm:flex vx-col w-full">
              <v-select
                class="sm:w-1/2 w-full"
                :options="tiposDatas"
                v-model="formFiltro.tipoData"
              ></v-select>

              <datepicker
                class="sm:w-1/2 w-full"
                :format="'dd/MM/yyyy'"
                placeholder="DD/MM/YYYY"
                v-model="formFiltro.dataInicial"
              ></datepicker>
            </div>
          </div>

          <div v-if="vistoria && !b2c" class="vx-col mt-3 sm:w-1/6 w-full">
            <span>Tipo de Data Inicial</span>
            <v-select
              style="width: 100%"
              :options="tiposDatas"
              v-model="formFiltro.tipoData"
            ></v-select>
          </div>
          <div v-if="vistoria && !b2c" class="vx-col mt-3 sm:w-1/6 w-full">
            <span>Data Inicial</span>
            <datepicker
              :format="'dd/MM/yyyy'"
              placeholder="DD/MM/YYYY"
              v-model="formFiltro.dataInicial"
            ></datepicker>
          </div>

          <div
            :class="`vx-col mt-3 ${
              !vistoria || b2c ? 'sm:w-1/5' : 'sm:w-1/6'
            } w-full`"
          >
            <span>Data Final</span>
            <datepicker
              :format="'dd/MM/yyyy'"
              placeholder="DD/MM/YYYY"
              v-model="formFiltro.dataFinal"
            ></datepicker>
          </div>

          <div v-if="vistoria && !b2c" class="vx-col mt-3 sm:w-1/6 w-full">
            <span>Status</span>
            <v-select
              :options="status"
              multiple
              name="Status"
              id="Status"
              v-model="formFiltro.status"
              :state="validateState('Status')"
              :class="validateClass('Status')"
            ></v-select>
          </div>
        </div>

        <div v-if="filtroAvancado == true" class="vx-row pb-0 sm:pb-4">
          <div v-if="!vistoria || b2c" class="vx-col sm:w-1/4 w-full mt-3">
            <span>Status</span>
            <v-select
              :options="status"
              multiple
              name="Status"
              id="Status"
              v-model="formFiltro.status"
              :state="validateState('Status')"
              :class="validateClass('Status')"
            ></v-select>
          </div>

          <div :class="`vx-col ${b2c ? 'sm:w-1/3' : 'sm:w-1/6'} w-full mt-3`">
            <span>Placa</span>
            <vs-input
              class="w-full"
              name="Placa"
              id="Placa"
              v-model="formFiltro.placa"
              :state="validateState('Placa')"
              :danger="validateClass('Placa')"
              val-icon-danger="clear"
            />
          </div>

          <!-- Associado -->
          <div :class="`vx-col ${b2c ? 'sm:w-1/3' : 'sm:w-1/3'} w-full mt-3`">
            <span>Nome do Beneficiário</span>
            <AutoComplete
              customClass="w-full"
              name="Associado"
              id="Associado"
              :configAutoComplete="{ model: 'associados', field: 'nome' }"
              v-model="formFiltro.nomeAssociado"
            />
          </div>

          <div :class="`vx-col ${b2c ? 'sm:w-1/3' : 'sm:w-1/4'} w-full mt-3`">
            <span>{{ $t('Consultor') }}</span>
            <v-select
              :options="consultores"
              name="Consultor"
              id="Consultor"
              class="input-uppercase"
              multiple
              v-model="formFiltro.consultor"
              :state="validateState('Consultor')"
              :class="validateClass('Consultor')"
            ></v-select>
          </div>

          <div
            :class="`vx-col sm:w-1/4 w-full ${!vistoria ? 'mt-4' : 'mt-3'}
            `"
          >
            <span>{{ $t('Divisão') }}</span>
            <v-select
              :options="divisoes"
              name="Divisao"
              id="Divisao"
              multiple
              v-model="formFiltro.divisao"
              :state="validateState('Divisao')"
              :class="validateClass('Divisao')"
            ></v-select>
          </div>

          <div
            :class="`vx-col ${b2c ? 'sm:w-1/3' : 'sm:w-1/4'} w-full ${
              !b2c && !vistoria ? 'mt-4' : 'mt-3'
            } w-full `"
          >
            <span>{{ $t('Regional') }}</span>
            <v-select
              :options="regionais"
              name="Regional"
              id="Regional"
              multiple
              v-model="formFiltro.regional"
              :state="validateState(translatedRegional)"
              :class="validateClass(translatedRegional)"
            ></v-select>
          </div>

          <div
            :class="`vx-col mt-3 ${
              !b2c && !vistoria ? 'sm:w-1/4' : 'sm:w-1/3'
            } w-full mt-4`"
          >
            <span>Tipo</span>
            <v-select
              :options="tiposProposta"
              multiple
              name="Tipo"
              id="Tipo"
              v-model="formFiltro.tipoCotacao"
              :state="validateState('Tipo')"
              :class="validateClass('Tipo')"
            ></v-select>
          </div>

          <div class="vx-col sm:w-1/6 w-full mt-4">
            <span>Estado</span>
            <v-select
              :options="estados"
              name="Estado"
              id="Estado"
              v-model="estado"
              @selected="buscaDadosSelectsCidades"
              :state="validateState('Estado')"
              :class="validateClass('Estado')"
            ></v-select>
          </div>

          <div
            :class="`vx-col ${
              !b2c && !vistoria ? 'sm:w-1/3' : 'sm:w-1/4'
            } w-full mt-3`"
          >
            <span>Cidade</span>
            <v-select
              :options="cidades"
              name="Cidade"
              id="Cidade"
              multiple
              v-model="formFiltro.cidade"
              :state="validateState('Cidade')"
              :class="validateClass('Cidade')"
            ></v-select>
          </div>

          <div class="vx-col sm:w-1/4 w-full mt-3">
            <span>Grupo</span>
            <v-select
              :options="grupos"
              name="Grupos"
              id="Grupos"
              multiple
              v-model="formFiltro.idGrupo"
              :state="validateState('Grupo')"
              :class="validateClass('Grupo')"
            ></v-select>
          </div>

          <div class="vx-col sm:w-1/4 w-full mt-3">
            <span>Cupons e Campanhas</span>
            <v-select
              :options="campanhas"
              multiple
              name="Cupons e Campanhas"
              id="Cupons e Campanhas"
              v-model="formFiltro.campanha"
              :state="validateState('Cupons e Campanhas')"
              :class="validateClass('Cupons e Campanhas')"
            ></v-select>
          </div>

          <div class="vx-col sm:w-1/6 w-full mt-3">
            <span>Origem</span>
            <v-select
              :options="origem"
              multiple
              name="Origem"
              id="Origem"
              v-model="formFiltro.origem"
              :state="validateState('Origem')"
              :class="validateClass('Origem')"
            ></v-select>
          </div>

          <div
            v-if="$can('Editar Responsável Vistoria', 'Vistorias') && vistoria"
            class="vx-col sm:w-1/4 w-full mt-3"
          >
            <label for="" class="vs-select--label"
              >Responsável pela analise de cadastro</label
            >
            <v-select
              :options="colaboradoresCadastro"
              name="Responsável pela Vistoria"
              label="label"
              id="idUsuarioResponsavelVistoria"
              v-model="formFiltro.responsaveisCadastroSelecionados"
              class="select-large w-full"
              :reduce="(item) => item.id"
              v-validate="{ required: true }"
              :state="validateState('Responsável pela Vistoria')"
              :danger="validateClass('Responsável pela Vistoria')"
              multiple
            ></v-select>
          </div>

          <div v-if="vistoria" class="vx-col sm:w-1/4 w-full mt-3">
            <span>Responsável pelo cadastro definido?</span>
            <v-select
              :options="[
                { id: 1, label: 'SIM' },
                { id: 0, label: 'NÃO' },
              ]"
              name="Responsável definido"
              id="Responsável definido"
              v-model="formFiltro.responsavelDefinido"
              :reduce="(item) => item.id"
              :state="validateState('Responsável definido')"
              :class="validateClass('Responsável definido')"
            ></v-select>
          </div>

          <div :class="`vx-col ${b2c ? 'sm:w-1/3' : 'sm:w-1/3'} w-full mt-3`">
            <span>CPF/CNPJ Beneficiário</span>
            <vs-input
              class="w-full"
              name="CPF"
              id="CPF"
              v-model="formFiltro.cpfCnpjAssociado"
              :state="validateState('CPF')"
              :danger="validateClass('CPF')"
              v-validate="{ min: 11 }"
              val-icon-danger="clear"
              danger-text="CPF ou CNPJ incompletos."
            />
          </div>

          <div class="vx-col sm:w-1/4 w-full mt-3">
            <label>Necessário Resync</label>
            <vs-switch class="mt-2" v-model="formFiltro.precisaResync" />
          </div>

          <div class="vx-col sm:w-1/6 w-full mt-3" v-if="b2c">
            <span>Origem App</span>
            <v-select
              :options="origemApp"
              name="Origem App"
              id="Origem App"
              v-model="formFiltro.insideApp"
              :state="validateState('Origem App')"
              :class="validateClass('Origem App')"
            ></v-select>
          </div>

          <div class="vx-col sm:w-1/6 w-full mt-3">
            <label>Com Retorno Pendente</label>
            <vs-switch class="mt-2" v-model="formFiltro.retornoPendencia" />
          </div>

          <div class="vx-col sm:w-1/4 w-full mt-3">
            <span>Chassi</span>
            <vs-input
              class="w-full"
              name="chassi"
              id="chassi"
              v-model="formFiltro.chassi"
              :state="validateState('chassi')"
              :danger="validateClass('chassi')"
              v-validate="{ min: 17 }"
              val-icon-danger="clear"
              danger-text="Chassi incorreto ou incompleto"
            />
          </div>
        </div>
      </form>
      <div slot="footer" style="margin-top: -1%">
        <br style="clear: both" />
        <vs-row class="flex justify-end">
          <vs-button
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-search"
            class="mr-3 mb-2"
            @click="buscar"
            >Buscar</vs-button
          >
          <vs-button
            @click="buscaFiltrosAvancados()"
            type="gradient"
            color="dark"
            icon-pack="feather"
            icon="icon-sliders"
          ></vs-button>
          <vs-button
            @click="limparFiltro"
            color="danger"
            type="gradient"
            icon-pack="feather"
            icon="icon-trash-2"
          ></vs-button>
        </vs-row>
      </div>
    </vs-card>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from './../../locale';
import Datepicker from 'vuejs-datepicker';
import * as lang from 'vuejs-datepicker/src/locale';
import vSelect from 'vue-select';
import service from '../../services';
import jwt from 'jsonwebtoken';
import AutoComplete from '../../components/autocomplete/AutoComplete.vue';
import notify from '../../utils/notify';
import { decryptData } from '../../services/decryptData';
import functions from '../../utils/functions';

export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
    vistoria: {
      type: Boolean,
    },
    b2c: {
      type: Boolean,
    },
  },
  watch: {
    estado(value) {
      this.formFiltro.estado = value;
      this.formFiltro.cidade = null;

      this.buscaDadosSelectsCidades(
        'domMunicipio',
        'cidades',
        'nomeCidade',
        'idCidade',
      );
    },
  },
  computed: {
    translatedRegional() {
      return this.$t('Regional');
    },
  },
  data() {
    return {
      colaboradoresCadastro: [],
      aguardeCadastro: false,
      idEmpresa: null,
      id_usuario: null,
      estados: [],
      cidades: [],
      grupos: [],
      regionais: [],
      consultores: [],
      status: [],
      campanhas: [],
      languages: lang,
      regionalDefault: [],
      regionaisUsuario: [],
      filtroAvancado: false,
      usuarios_regionais: [],
      origemApp: ['Sim', 'Não'],
      tiposProposta: [
        'Contratação',
        'Reativação',
        'Substituição',
        'Inclusão',
        'Troca de Titularidade',
        'Migração',
      ],
      tiposDatas: [
        'Data Cadastro',
        'Data Vistoria',
        'Data Finalização da Vistoria',
        'Data Finalização da Proposta',
      ],

      origem: ['B2C', 'Site', 'Network', 'Indicação'],
      estado: null,
      funcoesValicao: null,
      formFiltro: {
        idEmpresa: null,
        placa: null,
        nomeAssociado: null,
        consultor: null,
        regional: null,
        status: null,
        idGrupo: null,
        cidade: '',
        estado: '',
        tipoData: 'Data Cadastro',
        dataInicial: this.dataInicio(),
        dataFinal: new Date(),
        idProposta: null,
        tipoCotacao: null,
        campanha: null,
        precisaResync: null,
        retornoPendencia: null,
        responsaveisCadastroSelecionados: [],
        responsavelDefinido: null,
        cpfCnpjAssociado: '',
        chassi: null,
        divisao: null,
        idFrota: null,
      },
      divisoes: [],
      setor: null,
    };
  },
  methods: {
    limparFiltro() {
      this.formFiltro = {
        placa: null,
        nomeAssociado: null,
        consultor: null,
        regional: null,
        status: null,
        idGrupo: null,
        cidade: '',
        estado: '',
        tipoData: 'Data Cadastro',
        dataInicial: this.dataInicio(),
        dataFinal: new Date(),
        idProposta: null,
        tipoCotacao: null,
        campanha: null,
        cpfCnpjAssociado: '',
        divisao: null,
        idFrota: null,
      };
      this.buscar();
    },
    dataInicio() {
      var a = new Date();
      var b = a.setDate(a.getDate() - 1);
      return b;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data = decryptData(res.data);
        res.data.forEach((element) => {
          if (array == 'status' && this.vistoria == true) {
            if (
              element[campoPK] == 3 ||
              element[campoPK] == 4 ||
              element[campoPK] == 5 ||
              element[campoPK] == 7
            )
              this[array].push({
                id: element[campoPK],
                label: element[campoDescricao],
              });
          } else
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
        });
      });
    },
    buscaDadosGrupos() {
      service.getAll('Grupo', {}, 'list/' + this.idEmpresa).then((res) => {
        res.data.forEach((element) => {
          this.grupos.push({
            id: element.idGrupo,
            label: element.nomeGrupo,
          });
        });
      });
    },
    buscaCampanhas() {
      service.getAll('Campanha', {}, 'list/' + this.idEmpresa).then((res) => {
        res.data.forEach((element) => {
          this.campanhas.push({
            id: element.idCampanha,
            label: element.cupom,
          });
        });
      });
    },
    getDecoded() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.decoded = jwt.decode(token);
      }

      this.idEmpresa = this.decoded.id_empresa;
      this.id_usuario = this.decoded.id_usuario;
    },

    cleanString(str) {
      // Substituir caracteres acentuados usando regex
      str = str.replace(/[áàâãä]/g, 'a');
      str = str.replace(/[éèêë]/g, 'e');
      str = str.replace(/[íìîï]/g, 'i');
      str = str.replace(/[óòôõö]/g, 'o');
      str = str.replace(/[úùûü]/g, 'u');
      str = str.replace(/[ç]/g, 'c');

      // Converter para maiúsculas
      return str.toUpperCase();
    },

    async buscaDadosFiltros() {
      try {
        this.$vs.loading();

        await service
          .post('cotacao', 'busca-filtros-consultores-regionais', this.decoded)
          .then(({ data }) => {
            data.consultores.forEach((element) => {
              this.consultores.push({
                id: element.id_usuario,
                label: element.nome,
                //label: this.cleanString(element.nome),
              });
            });

            data.regionais.forEach((element) => {
              this.regionais.push({
                id: element.idRegional,
                label: element.nome,
                //label: this.cleanString(element.nome),
              });
            });
          });
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Falha ao buscar filtros',
          text: error,
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    buscaDadosSelectsCidades(model, array, campoDescricao, campoPK) {
      if (!this.formFiltro.estado) {
        return;
      }

      this.$vs.loading();

      this[array] = [];
      service
        .getAll('g', {}, `${model}/list/codUf/${this.formFiltro.estado.id}`)
        .then((res) => {
          res.data = decryptData(res.data);
          res.data.forEach((element) => {
            this[array].push({
              id: element[campoPK],
              //label: this.cleanString(element[campoDescricao]),
              label: element[campoDescricao],
            });
          });

          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.loading.close();

          this.$vs.notify({
            position: 'top-center',
            title: 'Falha buscar cidades',
            text: e,
            color: 'danger',
          });
        });
    },
    buscar() {
      this.formFiltro.filtred = true;

      const sendFiltro = { ...this.formFiltro };
      let possuiFiltroContratacao;

      if (sendFiltro.tipoCotacao && Array.isArray(sendFiltro.tipoCotacao)) {
        possuiFiltroContratacao =
          sendFiltro.tipoCotacao.includes('Contratação');
      }

      if (possuiFiltroContratacao) {
        sendFiltro.tipoCotacao = sendFiltro.tipoCotacao.map((item) =>
          item === 'Contratação' ? 'Adesão' : item,
        );
      }

      this.$emit('filtro', sendFiltro);
    },
    async buscaColaboradoresDoCadastro() {
      const idSetorCadastro = await this.buscarIdDoSetorCadastro();
      service
        .post('Usuario', 'buscarUsuario', {
          idEmpresa: this.idEmpresa,
          idSetor: idSetorCadastro.id,
        })
        .then((res) => {
          this.colaboradoresCadastro = res.data.map((colaborador) => {
            return {
              id: colaborador.idUsuario,
              label: colaborador.nome,
            };
          });
          this.colaboradoresCadastro.unshift({ label: 'Selecione', id: null });

          this.$emit('obterColaboradoresCadastro', this.colaboradoresCadastro);
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
    buscarIdDoSetorCadastro() {
      return new Promise((resolve, reject) => {
        service
          .post('Setor', 'buscar-id-setor-por-nome', {
            idEmpresa: this.idEmpresa,
            nomeSetor: 'cadastro',
          })
          .then((res) => {
            resolve(res.data);
          })
          .catch((e) => {
            this.$vs.loading.close();
            reject(e);
          });
      });
    },
    buscaDadosSelectDivisoes(model, array, campoDescricao, campoPK) {
      service
        .getAll('g', {}, `${model}/list/idEmpresa/${this.idEmpresa}`)
        .then((res) => {
          res.data = decryptData(res.data);
          res.data.forEach((element) => {
            this[array].unshift({
              id: element[campoPK],
              label: element[campoDescricao],
            });
          });

          this[array].sort(function (a, b) {
            if (a.label > b.label) {
              return 1;
            }

            if (a.label < b.label) {
              return -1;
            }

            return 0;
          });
        });
    },
    async buscaFiltrosAvancados() {
      if (!this.filtroAvancado) {
        this.filtroAvancado = true;

        if (this.grupos.length == 0) {
          this.buscaDadosGrupos();
          this.buscaDadosFiltros();
          this.buscaCampanhas();

          this.buscaDadosSelects('domUf', 'estados', 'nomeUf', 'codUf');
          this.buscaDadosSelects('domUf', 'estados', 'nomeUf', 'codUf');
          this.buscaDadosSelectDivisoes(
            'divisoes',
            'divisoes',
            'nomeDivisao',
            'idDivisao',
          );
          if (this.status.length == 0) {
            this.buscaDadosSelects(
              'domStatusCotacao',
              'status',
              'nomeStatus',
              'idStatus',
            );
          }
        }
      } else this.filtroAvancado = false;

      this.preencheFiltroDivisao();
    },
    async buscarDadosSetor(idSetor) {
      try {
        const { data } = await service.post('Setor', `find/${idSetor}`, {});
        return data;
      } catch (error) {
        notify.notifyFail(
          this.$vs,
          'Falha ao buscar dados do setor',
          'Atenção',
          'danger',
          5000,
        );
      }
    },
    async definirDadosSetor() {
      try {
        const idSetor = this.decoded.id_setor;
        this.setor = await this.buscarDadosSetor(idSetor);
      } catch (error) {
        notify.notifyFail(
          this.$vs,
          'Falha ao definir os dados do setor',
          'Atenção',
          'danger',
          5000,
        );
      }
    },
    preencheFiltroDivisao() {
      if (this.setor && this.setor.nomeSetor === 'Cadastro') {
        this.formFiltro.divisao = this.divisoes;
      }
    },
  },
  async created() {
    this.getDecoded();
    await this.definirDadosSetor();

    if (this.vistoria) {
      this.buscaDadosSelects(
        'domStatusCotacao',
        'status',
        'nomeStatus',
        'idStatus',
      );
      this.buscaColaboradoresDoCadastro();
    }
    this.$validator.localize('ptBr', locale);
  },
  mounted() {
    this.preencheFiltroDivisao();
    this.$i18n.locale = functions.setLocaleBasedOnCompany();
  },
  components: {
    Datepicker,
    'v-select': vSelect,
    AutoComplete,
  },
};
</script>
<!------------ END SCRIPT ------------>
<style>
.vs__dropdown-toggle {
  padding: 4px 0 6px 0 !important;
}

.vdp-datepicker input {
  width: 100%;
}

.vdp-datepicker__calendar {
  z-index: 900 !important;
}

.input-uppercase input {
  text-transform: uppercase;
}
</style>
